<template>
    <div>
      <div class="container" style="padding: 0.5em;"> <br/>
        <h3>
          Simply highlight text as <b class="annot8-hl-facts">&nbsp;FACTS </b>, <b class="annot8-hl-issues">&nbsp;ISSUES </b>, <b class="annot8-hl-ruling">&nbsp;RULING </b>, <b class="annot8-hl-principles">&nbsp;PRINCIPLES </b>. 
        </h3>
        <br/>
        <!-- <iframe width="980" height="551" src="https://www.youtube.com/embed/FKI0-UBhIQ0?feature=oembed" frameborder="0" allowfullscreen=""></iframe> -->
      </div>
    </div>
</template>

<script>
export default {
    
}
</script>